// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpyMaster .find-card-wrapper {
  text-align: center; }
  .SpyMaster .find-card-wrapper .btn {
    display: inline-block; }

.SpyMaster input {
  margin: 1rem; }

.SpyMaster .container.spy-master {
  flex-direction: column;
  min-height: 80vh; }

.SpyMaster .title {
  text-align: center;
  font-size: 3.5rem; }
  @media only screen and (max-width: 900px) {
    .SpyMaster .title {
      font-size: 2.5rem; } }
  @media only screen and (max-width: 525px) {
    .SpyMaster .title {
      font-size: 2rem; } }
`, "",{"version":3,"sources":["webpack://./src/routes/SpyMaster.scss"],"names":[],"mappings":"AAAA;EAEI,kBAAkB,EAAA;EAFtB;IAKM,qBAAqB,EAAA;;AAL3B;EAUI,YAAY,EAAA;;AAVhB;EAcI,sBAAsB;EACtB,gBAAgB,EAAA;;AAfpB;EAmBI,kBAAkB;EAClB,iBAAiB,EAAA;EAEjB;IAtBJ;MAuBM,iBAAiB,EAAA,EAMpB;EAHC;IA1BJ;MA2BM,eAAe,EAAA,EAElB","sourcesContent":[".SpyMaster {\n  .find-card-wrapper {\n    text-align: center;\n\n    .btn {\n      display: inline-block;\n    }\n  }\n\n  input {\n    margin: 1rem;\n  }\n\n  .container.spy-master {\n    flex-direction: column;\n    min-height: 80vh;\n  }\n\n  .title {\n    text-align: center;\n    font-size: 3.5rem;\n\n    @media only screen and (max-width: 900px) {\n      font-size: 2.5rem;\n    }\n\n    @media only screen and (max-width: 525px) {\n      font-size: 2rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
